export function removeDuplicatesFromArray<T>(arr: T[], key: keyof T): T[] {
  return arr.reduce<T[]>((unique, item) => {
    if (!unique.find(obj => obj[key] === item[key])) {
      unique.push(item);
    }
    return unique;
  }, []);
}
